import React, { useEffect } from 'react';

import { Button } from 'reactstrap';
import withOpenState from './withOpenState';

const ToggleModalButtonAddSelect = ({ ComponentModal = null, ...props }) => {
   useEffect(() => {
      if (props.modalOpenCb) {
         props.modalOpenCb(props.isOpen);
      }
   }, [props.isOpen]);

   return (
      <div className={`h-100 d-flex flex-column justify-content-center ${ props.className }`}>
         <Button
            color='link'
            type='button'
            onClick={ props.toggleIsOpen }
         >
            {/* <i className="far fa-angle-double-right"/> */}
            <i className='far fa-chevron-circle-right'/>
         </Button>
         {
            props.isOpen && ComponentModal && <ComponentModal { ...props } />
         }
      </div>
   );
};

export default withOpenState(ToggleModalButtonAddSelect);
